import styled from "@emotion/styled";

export const BrowseHeaderContent = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem 0.5rem 0.5rem 0;
`;

export const BrowseHeaderIconContainer = styled.div`
  display: flex;
  align-items: center;
  color: var(--mb-color-text-medium);

  &:hover {
    color: var(--mb-color-brand);
  }
`;
